// CRA transpiles syntax for the browserslist targets but does not polyfill newer built-in APIs.
// MUI / MUI-X call these at runtime, and older Android WebViews / iOS < 15.4 (e.g. inside the
// Facebook or Instagram apps) don't have them, so a missing one throws and breaks the page.

function define(target, name, value) {
  if (!(name in target)) {
    Object.defineProperty(target, name, { value, writable: true, configurable: true, enumerable: false });
  }
}

define(Object, "hasOwn", function hasOwn(obj, key) {
  return Object.prototype.hasOwnProperty.call(Object(obj), key);
});

function at(index) {
  const len = this.length;
  let i = Math.trunc(index) || 0;
  if (i < 0) i += len;
  return i < 0 || i >= len ? undefined : this[i];
}
define(Array.prototype, "at", at);
define(String.prototype, "at", at);

define(Array.prototype, "findLast", function findLast(predicate, thisArg) {
  for (let i = this.length - 1; i >= 0; i -= 1) {
    if (predicate.call(thisArg, this[i], i, this)) return this[i];
  }
  return undefined;
});

define(Array.prototype, "findLastIndex", function findLastIndex(predicate, thisArg) {
  for (let i = this.length - 1; i >= 0; i -= 1) {
    if (predicate.call(thisArg, this[i], i, this)) return i;
  }
  return -1;
});

define(String.prototype, "replaceAll", function replaceAll(search, replacement) {
  if (search instanceof RegExp) return this.replace(search, replacement);
  return this.split(String(search)).join(
    typeof replacement === "function" ? replacement(String(search)) : String(replacement),
  );
});

// JSON round-trip is enough for the plain option objects MUI clones.
define(window, "structuredClone", function structuredClone(value) {
  return value === undefined ? undefined : JSON.parse(JSON.stringify(value));
});
